import React, { useEffect, useState, useContext } from "react";
import { getshopanalysis } from "../../../Utility/Api";
import { getFormattedCurrentDate2, shop_id } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import {
  FaBox,
  FaMoneyBillWave,
  FaUserTie,
  FaHandHoldingUsd,
  FaTruck,
} from "react-icons/fa";

const ShopData = () => {
  const { showLoader, hideLoader } = useContext(WarehouseContext);
  const [data, setData] = useState({});
  const [fromDate, setFromDate] = useState(getFormattedCurrentDate2());
  const [toDate, setToDate] = useState(getFormattedCurrentDate2());
  const shop=JSON.parse(localStorage.getItem("SHOP"));
  const ShopTitle=shop?.shop_title||"SHOP";

  const fetchShopData = async () => {
    try {
      showLoader();
      const params = `start_date=${fromDate}&end_date=${toDate}&shop_id=${shop_id}`;
      const response = await getshopanalysis(params);
      if (response.data.data) {
        setData(response.data.data);
      }
      hideLoader();
    } catch (error) {
      console.error("Error fetching shop analytics:", error);
      hideLoader();
    }
  };

  useEffect(() => {
    fetchShopData();
  }, [fromDate, toDate]);

  const metrics = [
    {
      label: "Total Products",
      value: data?.total_products_added,
      icon: <FaBox className="text-primary" />,
    },
    {
      label: "Total Sales",
      value: data?.total_sales,
      icon: <FaMoneyBillWave className="text-success" />,
    },
    {
      label: "Sales Cost",
      value: data?.total_sales_cost,
      icon: <FaMoneyBillWave className="text-secondary" />,
    },
    {
      label: "Purchase Cost",
      value: data?.total_purchase_cost,
      icon: <FaHandHoldingUsd className="text-warning" />,
    },
    {
      label: "Total Profit",
      value: data?.total_profit,
      icon: <FaMoneyBillWave className="text-success" />,
    },
    {
      label: "Total Loss",
      value: data?.total_loss,
      icon: <FaMoneyBillWave className="text-danger" />,
    },
    {
      label: "Total Purchases",
      value: data?.total_purchases,
      icon: <FaTruck className="text-info" />,
    },
    {
      label: "Sales Credit",
      value: data?.sales_credit,
      icon: <FaMoneyBillWave className="text-dark" />,
    },
    {
      label: "Purchase Credit",
      value: data?.purchase_credit,
      icon: <FaMoneyBillWave className="text-primary" />,
    },
    {
      label: "Service Credit",
      value: data?.service_credit,
      icon: <FaHandHoldingUsd className="text-info" />,
    },
    {
      label: "Total Credit",
      value: data?.total_credit,
      icon: <FaMoneyBillWave className="text-success" />,
    },
    {
      label: "Customers Ordered",
      value: data?.total_customers_ordered,
      icon: <FaUserTie className="text-secondary" />,
    },
    {
      label: "Total Suppliers",
      value: data?.total_suppliers,
      icon: <FaTruck className="text-dark" />,
    },
  ];

  return (
    <div className=" p-3 my-3">
      <div className="row ">
        <div className="col">
          {/* <h5 className="text-uppercase fw-semibold text-dark">{ShopTitle} : Shop Analytics  </h5> */}
          <h5 className="text-uppercase fw-semibold text-dark">   Shop Analytics  </h5>
          <hr />
        </div>
      </div>

      <div className="row bg-white text-center  mx-1">
        <div className="col d-flex justify-content-end gap-3 mt-2  flex-wrap mb-2">
          <div className="col-md-2">
            <div className="form-floating">
              <input
                type="date"
                className="form-control"
                value={fromDate}
                max={toDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
              <label>From Date</label>
            </div>
          </div>

          <div className="col-md-2">
            <div className="form-floating">
              <input
                type="date"
                className="form-control"
                value={toDate}
                min={fromDate}
                onChange={(e) => setToDate(e.target.value)}
              />
              <label>To Date</label>
            </div>
          </div>
        </div>
      </div>

      {/* Metric Cards */}
      <div className="row g-4 bg-light  mt-1 mx-2">
        {metrics.map((metric, index) => (
          <div className=" product-grid col-xl-4 col-lg-6 col-md-6 my-2" key={index}>
            <div className="card  h-100 border-0 shadow-xl hover-effect ">
              <div className="card-body  d-flex justify-content-between align-items-center">
                <div>
                  <p className="text-muted mb-1 small">{metric.label}</p>
                  <h5 className="fw-bold text-dark">
                    {(metric.value ?? 0).toFixed(0)}
                  </h5>
                </div>
                <div className="fs-2">{metric.icon}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShopData;
